import { makeAutoObservable, runInAction, toJS } from 'mobx';
import axios from 'axios'

class Document {
  
  document = {}
  search_results = []
  
  constructor(){

    makeAutoObservable(this)

    this.document = {}
    this.search_results = []
    
  }
  
  fetch = (id) => {
    
    this.document = {}
    
    axios.get('https://holdmyticket.com/api/public/documents/get/'+id)
    .then((response) => {
      var data = response.data
      // data.content_markdown = data.content_markdown.replace(/#/g, '#').replace(/# #/g, '##').replace(/# #/g, '##').replace(/# #/g, '##')
      runInAction(() => {
        this.document = data
      })
    })
    .catch(function (error) {
      console.log(error);
    })

  }
  
  search = (query) => {
    
    axios.get('https://holdmyticket.com/api/public/documents/search/'+query)
    .then((response) => {
      runInAction(() => {
        this.search_results = response.data.results
      })
    })
    .catch(function (error) {
      console.log(error);
    })
    
  }
  
  get read(){
    return toJS(this.document)
  }
  
  get results(){
    return toJS(this.search_results)
  }

}

export default Document